export const ArrowDownSmall = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M10.0005 10.9763L14.1254 6.85156L15.3039 8.03007L10.0005 13.3334L4.69727 8.03007L5.87577 6.85156L10.0005 10.9763Z"
      fill="currentColor"
    />
  </svg>
);
